enum PlannerFilters {
  YEAR = 'year',
  MONTH = 'month',
  SEARCH = 'search',
  TRAINING_TYPE = 'trainingType',
  STATE = 'state',
}

export default PlannerFilters;
